document.addEventListener("DOMContentLoaded", pdpGuarantee);

function pdpGuarantee() {
  console.log("pdpGuarantee");

  const refs = {
    warrantyCheckbox: document.getElementById("warranty-checkbox"),
    warantyRadio: document.querySelectorAll(
      ".extended-warranty [name='warranty']"
    ),
    atcButton: document.querySelector(".product-form__submit"),
    cartDrawer: document.querySelector("#CartDrawer"),
  };

  if(!refs.warrantyCheckbox) return;

  console.log("guarantee refs", refs);

  let guarantyCheck = false;
  let guarantyOption = "Гарантія на 1 рік";
  let guarantyType = 1;

  refs.warrantyCheckbox.addEventListener("click", (event) => {
    const { checked } = event.target;

    guarantyCheck = checked;
  });

  refs.warantyRadio.forEach((radio) => {
    radio.addEventListener("change", (event) => {
      const { guaranty } = event.target.dataset;
      console.log(guaranty);

      if (event.target.checked) {
        guarantyOption = guaranty;
        guarantyType = guaranty.includes("1") ? 1 : 2;
      };
    });
  });


  refs.atcButton.addEventListener("click", async (event) => {
    if (!guarantyCheck) return;
    
    console.log({
      title: guarantyOption,
      description: `Продукт id ${window.productID}`,
      price: window.productPrice,
      type: guarantyType,
    });

    refs.cartDrawer.classList.add("loading");
    
    const guarantyInfo = await fetch(
      "https://magnificent-app-c2048.ampt.app/api/createProduct",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          title: `${guarantyOption} - ${window.productTitle}`,
          description: `Продукт id ${window.productID}`,
          price: window.productPrice,
          type: guarantyType,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: res.data.variants[0].id,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Гарантия добавлена в корзину:", data);

            //Обновляем корзину
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                for (const selector of selectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = html.querySelector(selector);
                  if (targetElement && sourceElement) {
                    //targetElement.replaceWith(sourceElement);

                    console.log("targetElement", targetElement);

                    // Переместите блоки, которые хотите сохранить, временно.
                    const blocksToKeep = targetElement.querySelectorAll('.block-to-keep');
                    blocksToKeep.forEach(block => block.remove());
                    // Обновите содержимое целевого элемента.
                    targetElement.replaceWith(sourceElement);
                    // Верните блоки обратно.
                    const newTargetElement = document.querySelector(selector);
                    blocksToKeep.forEach(block => newTargetElement.appendChild(block));
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              });
            
            //location.reload();
          })
          .catch((error) => {
            console.error("Ошибка при добавлении гарантии:", error);
          });
      })
      .catch((err) => console.error(err))
      .finally(()=>{
        refs.cartDrawer.classList.remove("loading");
      });

  });

}
